import styled from 'styled-components'

import type { BoxProps } from './Box'

export const StyledBox = styled.div<BoxProps>`
  margin: 0;
  ${props => props.inset && `padding: ${props.theme.spacingsInset[props.inset]};`}
`
